import '../css/loaderTabla.css';
export const LoaderTabla = () => {
    return (
        <div className='mt-5 text-center'>
            <span class="loaderTabla mx-auto"></span>
            <span class="loaderTexto mt-4">Cargando</span>
        </div>
    )
}